<template>
    <div class="doctor-details">
        <div class="doctor-details-wapper">
            <div class="doctor-details-wapper-bg"></div>
            <div class="doctor-details-wapper-bg-right"></div>
        </div>
        <!-- 内容区域 -->
        <div class="doctor-details-container">
            <div :class="['doctor-details-container-header']">
                <div class="doctor-details-container-header-info">
                    <div class="doctor-details-container-header-info-name">
                        <span>{{ doctorInfo.name }}</span>
                        <span>{{ doctorInfo.position }}</span>
                    </div>
                    <van-image fit="cover" :src="doctorInfo.avatar" />
                </div>

                <div class="doctor-details-container-header-resume">
                    <div v-for="(item, index) in doctorInfo.hospitals" :key="index">
                        {{ item.hospital }} | {{ item.office }}
                    </div>
                </div>

                <div class="doctor-details-container-header-tags" v-if="doctorInfo.tags">
                    <van-tag
                        type="primary"
                        :color="tagsType[index].color"
                        :text-color="tagsType[index].textColor"
                        v-for="(item, index) in tagList"
                        :key="index"
                        >{{ item }}</van-tag
                    >
                </div>

                <div class="doctor-details-container-header-synopsis">
                    <div class="doctor-details-container-header-synopsis-item">
                        <div>擅长：</div>
                        <div v-html="doctorInfo.adept_at"></div>
                    </div>
                    <div :class="['doctor-details-container-header-synopsis-item', tagList ? 'is-height' : '']">
                        <div>简介：</div>
                        <div :class="[isOpen ? 'open' : 'shrink']" v-html="doctorInfo.desc"></div>
                    </div>
                </div>

                <div v-if="doctorInfo.desc" class="doctor-details-container-header-operation">
                    <div v-if="!isOpen" @click="isOpen = !isOpen">
                        展开
                        <van-icon name="arrow-down" />
                    </div>
                    <div v-else @click="isOpen = !isOpen">
                        收缩
                        <van-icon name="arrow-up" />
                    </div>
                </div>
            </div>

            <div class="doctor-details-container-content" v-if="pageList.length > 0">
                <van-tabs v-model="active" sticky @click="onTabsClick">
                    <van-tab title="直播" name="live"></van-tab>
                    <van-tab title="文章" name="article"></van-tab>
                    <van-tab title="音视频" name="video"></van-tab>
                </van-tabs>
                <div class="curriculum-list">
                    <van-list v-model="loading" :finished="finished" finished-text="已到底部" @load="onLoad">
                        <template v-for="listItem in pageList">
                            <ListItem v-if="listItem" :item="listItem" :key="listItem.id" />
                        </template>
                    </van-list>
                </div>

                <div class="contact-doctor">
                    <van-button round size="normal" block color="#03cbbf" type="info" @click="overlayShow = true">
                        和医生联系
                    </van-button>
                </div>
            </div>
        </div>
        <van-overlay class-name="manual-list-overlay" :show="overlayShow" @click="overlayShow = false">
            <div class="manual-list-overlay-content" @click.stop>
                <div class="manual-list-overlay-content-main">
                    <span>添加小助手</span>
                    <span class="selected">长按识别二维码，加小助手获得医生联系方式</span>
                    <van-image src="/static/bytx/anticancer/zj.jpeg" />
                    <van-image
                        class="close-icon"
                        src="/static/bytx/anticancer/close-icon.svg"
                        @click="overlayShow = false"
                    />
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import homeSkeleton from '@/skeleton/homeSkeleton'
import ListItem from './item.vue'
export default {
    components: {
        ListItem,
        homeSkeleton
    },
    computed: {
        tagsType() {
            if (this.tagList.length) {
                const tmp = [
                    { color: '#E6FAF7', textColor: '#0CC4B9' },
                    { color: '#EDF0FD', textColor: '#728DE8' },
                    { color: '#EBF7FE', textColor: '#57AAEF' },
                    { color: '#FFF9F1', textColor: '#FEA253' },
                    { color: '#E6FAF7', textColor: '#0CC4B9' },
                    { color: '#EDF0FD', textColor: '#728DE8' },
                    { color: '#EBF7FE', textColor: '#57AAEF' },
                    { color: '#FFF9F1', textColor: '#FEA253' }
                ]
                if (this.tagList.length > tmp.length) {
                    tmp.push(...tmp)
                }

                return tmp
            }
        },
        tagList() {
            if (this.doctorInfo && this.doctorInfo.tags) {
                return this.doctorInfo.tags.split(',') || []
            } else {
                return []
            }
        }
    },

    data() {
        return {
            overlayShow: false,
            active: 'live',
            doctorInfo: {},
            isOpen: false,
            pageList: [],
            page: {
                page: 1,
                pageSize: 5
            },
            total: 0,
            loading: false,
            finished: false
        }
    },
    methods: {
        onTabsClick() {
            this.page = { page: 1, pageSize: 5 }
            this.fetchList()
        },
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetchList()
        },
        fetchList() {
            Interface.getData(
                'get',
                `${Interface.anticancer.professor}/${this.active}/${this.$route.params.id}`,
                this.page
            ).then(res => {
                if (this.loading) {
                    this.pageList = [...this.pageList, ...res.data.list]
                } else {
                    if(res.data.list){
                        this.pageList = res.data.list
                    }
                }
                this.total = res.data.total
                this.loading = false

                if (this.pageList.length >= this.total && this.pageList.length > 0) {
                    this.finished = true
                } else {
                    this.finished = false
                }
            })
        },
        fetch(scene) {
            if (scene === 'index') {
                Interface.getData('get', `${Interface.anticancer.professor}/${this.$route.params.id}`).then(res => {
                    this.doctorInfo = res.data
                    Interface.getShareInfo(this, '专家详情-' + this.doctorInfo.name, this.doctorInfo.avatar, '')
                })
            }
        }
    },
    created() {
        this.fetch('index')
        this.fetchList()
    }
}
</script>

<style lang="scss">
.doctor-details {
    background: #f5f5f6;
    position: relative;
    height: 98vh;

    &-wapper {
        &-bg {
            position: absolute;
            background: url('/static/bytx/medical_head_bg@3x.png') no-repeat;
            background-size: 100% 100%;
            background-position: 100% 100%;
            width: 375px;
            height: 179px;
        }

        &-right {
            width: 170px;
            height: 123px;
            background: linear-gradient(284deg, #40dfc4 0%, #19d3c4 100%);
            border: 1px solid;
            border-image: linear-gradient(221deg, rgba(62, 222, 200, 1), rgba(31, 213, 196, 0)) 1 1;
        }
    }

    &-container {
        position: absolute;
        width: 100%;
        box-sizing: border-box;

        padding-top: 54px;

        &-header {
            margin: 0px 12px;
            background: #fff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-left: 18px;
            padding-right: 14px;
            padding-bottom: 10px;

            &-info {
                display: flex;
                justify-content: space-between;

                &-name {
                    padding-top: 20px;
                    span {
                        &:nth-child(1) {
                            font-size: 20px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #222222;
                        }
                        &:nth-child(2) {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #222222;
                        }
                    }
                }

                .van-image,
                .van-image__img {
                    // border-radius: 50%;
                    margin-top: -20px;
                    width: 66px;
                    height: 80px;
                }
            }

            &-resume {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                padding-top: 10px;
                padding-bottom: 15px;
            }

            &-tags {
                margin-top: 20px;
                margin-bottom: 16px;
                .van-tag {
                    padding: 2px 4px;
                    font-size: 10px;
                    margin-right: 6px;
                }
            }

            &-synopsis {
                &-item {
                    display: flex;
                    margin-bottom: 15px;

                    div:nth-child(1) {
                        flex: 20px;
                        text-align: right;
                        font-weight: 700;
                        font-size: 12px;
                    }
                    div:nth-child(2) {
                        flex: 80%;
                        font-size: 12px;
                        color: #747272;
                    }
                }

                .is-height {
                    margin-top: 30px;
                }
            }

            &-operation {
                div {
                    margin-top: 15px;
                    display: flex;
                    justify-content: center;
                    align-items: flex-end;
                    font-size: 13px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #acadaf;

                    .van-icon {
                        font-size: 12px;
                        padding-bottom: 2px;
                    }
                }
            }
        }

        .open {
            overflow: auto;
        }

        .shrink {
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            display: -webkit-box;
            -webkit-line-clamp: 2; // 超出多少行
            -webkit-box-orient: vertical;
        }
    }
}

.doctor-details-container-content {
    margin-top: 10px;

    .van-tabs {
        .van-tabs__wrap {
            border-radius: 12px 12px 0 0;
        }
        .van-tabs__line {
            background: #19d3c4;
            width: 20px;
        }

        .van-tab {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9d9d9d;
        }
        .van-tab--active {
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #222222;
        }

        .van-tabs__content {
            background: #fff;
        }
    }

    // 相关推荐
    .curriculum-list {
        background-color: #fff;
        padding-top: 1px;

        .card-item {
            background-color: #fff;
            border-radius: 6px;
            padding: 10px;
            display: flex;
            border-bottom: 1px solid #f5f5f5;

            &-header {
                position: relative;
                .van-image {
                    width: 112px;
                    height: 66px;
                    border-radius: 6px;
                    img {
                        border-radius: 6px;
                    }
                }

                span {
                    display: inline-block;
                    font-size: 10px;
                    padding: 3px 5px;
                    position: absolute;
                    left: 2px;
                    top: 2px;
                    background: #d48e50;
                    color: #fff;
                    border-radius: 4px;
                }

                .van-icon {
                    position: absolute;
                    left: 35%;
                    top: 28%;
                    font-size: 40px;
                    color: #fff;
                }
            }

            &-content {
                width: 100%;
                color: #333;
                padding-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    font-size: 13px;
                    font-weight: 500;
                    padding-left: 5px;
                }

                &-footer {
                    display: flex;
                    align-items: center;
                    font-size: 10px;
                    color: #858181;
                    span:nth-child(1) {
                        margin-right: 10px;
                    }
                }
            }
        }

        .van-list {
            padding-bottom: 70px;
        }
    }

    .contact-doctor {
        position: fixed;
        bottom: 0;
        background: #fff;
        width: 100%;
        height: 60px;
        border-top: 1px solid #f4f4f4;
        box-sizing: border-box;
        padding: 10px 20px;
        padding-bottom: 64px;

        .van-button {
            background: #03cbbf;
        }
    }
}

.manual-list-overlay-content {
    display: flex;
    justify-content: center;
    padding-top: 134px;

    .manual-list-overlay-content {
        &-main {
            border-radius: 10px;
            width: 285px;
            height: 280px;
            background: #ffffff;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            .close-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 20px !important;
                height: 20px !important;

                .van-image__img {
                    width: 20px;
                    height: 20px;
                }
            }
            .van-image {
                width: 140px;
                height: 140px;
            }

            span {
                &:nth-child(1) {
                    font-family: PingFangSC-Semibold;
                    font-size: 14px;
                    color: #282828;
                    letter-spacing: 0;
                    text-align: center;
                    margin-top: 18px;
                    margin-bottom: 1px;
                }

                &:nth-child(2) {
                    font-family: PingFangSC-Regular;
                    font-size: 10px;
                    color: #404040;
                    letter-spacing: 0;
                    text-align: center;
                    margin-top: 12px;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/doctor-details/index.vue